<template>
    <v-dialog :value="show" max-width="720" @input="onClose">
        <v-card>
            <v-card-title>
                Vincular turma à trilha
                <v-spacer />
                <v-btn icon @click="onClose(false)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    v-model="search"
                    label="Buscar turma"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                />
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredItems"
                    :loading="loading"
                    show-select
                    item-key="id"
                    dense
                    hide-default-footer
                    :items-per-page="50"
                >
                    <template v-slot:item.work_time="{ item }">
                        {{ item.work_time ? item.work_time.name : '—' }}
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="onClose(false)">Cancelar</v-btn>
                <v-btn
                    color="primary"
                    :disabled="!selected.length"
                    :loading="submitting"
                    @click="submit"
                >
                    Vincular ({{ selected.length }})
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed, getCurrentInstance, ref, watch } from 'vue'

export default {
    name: 'TrailLinkDialog',
    props: {
        show:             { type: Boolean, default: false },
        groupId:          { type: [Number, String], required: true },
        courseId:         { type: [Number, String], default: null },
        currentWorkTimeId:{ type: [Number, String], default: null },
        excludedIds:      { type: Array, default: () => [] },
        excludedNames:    { type: Array, default: () => [] },
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance()
        const search = ref('')
        const items = ref([])
        const selected = ref([])
        const loading = ref(false)
        const submitting = ref(false)

        const headers = [
            { text: 'Período', value: 'work_time', sortable: false },
            { text: 'Turma',   value: 'name',      sortable: false },
            { text: 'Código',  value: 'code',      sortable: false },
        ]

        const fetchCandidates = async () => {
            if (!props.courseId) {
                items.value = []
                return
            }
            loading.value = true
            try {
                const res = await proxy.$store.dispatch('domainLearningPath/ActionGetLearningPathGroups', {
                    courseId: props.courseId,
                })
                const excludedIdSet = new Set(props.excludedIds)
                const norm = (s) => (s || '').toString().trim().toLowerCase()
                const excludedNameSet = new Set(props.excludedNames.map(norm))
                const currentWt = props.currentWorkTimeId ? Number(props.currentWorkTimeId) : null
                items.value = (Array.isArray(res) ? res : [])
                    .filter((g) => !excludedIdSet.has(g.id))
                    .filter((g) => !excludedNameSet.has(norm(g.name)))
                    // Não permite vincular turma do MESMO período letivo da âncora
                    // (duas turmas paralelas, não fazem parte da mesma trilha temporal).
                    // Defensivo: se g.work_time não veio (ou currentWt é null), mantém.
                    .filter((g) => {
                        if (!currentWt) return true
                        if (!g.work_time || g.work_time.id == null) return true
                        return Number(g.work_time.id) !== currentWt
                    })
            } finally {
                loading.value = false
            }
        }

        const filteredItems = computed(() => {
            if (!search.value) return items.value
            const q = search.value.toLowerCase()
            return items.value.filter((g) =>
                (g.name || '').toLowerCase().includes(q) ||
                (g.code || '').toLowerCase().includes(q)
            )
        })

        const onClose = () => { emit('update:show', false) }

        const submit = async () => {
            submitting.value = true
            try {
                emit('link', selected.value.map((g) => g.id))
                selected.value = []
            } finally {
                submitting.value = false
            }
        }

        watch(() => props.show, (v) => {
            if (v) {
                selected.value = []
                fetchCandidates()
            }
        })

        return { search, items, selected, loading, submitting, headers, filteredItems, onClose, submit }
    },
}
</script>
